module.exports = " <span v-text=text :class=\"['vux-badge', {'vux-badge-single': text.length === 1}]\"></span> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/badge/index.vue
// module id = 201
// module chunks = 2